// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"318":"owl-carousel","463":"bootstrap-core-landing"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".bundle.min.js";
};